import React, { Fragment } from 'react';
import T from 'prop-types';

import SmartChart from '../../../../../../components/Chart/SmartChart';
import ChartLegend from './ChartLegend';

const colors = ['#348BE3', '#ED5588', '#35ABB2', '#A55DC7', '#F4CD86'];
const marketAvg = {
  id: 'market_avg',
  name: 'Market Average',
  color: '#15385B',
};

const ReleasesChart = ({ series, selectedApps }) => {
  const presentApps = Object.keys(series);
  const appsData = selectedApps
    .filter((app) => presentApps.includes(app.ref_no.toString()))
    .map((app, index) => ({
      id: app.ref_no,
      name: app.name,
      icon_url: app.icon_url,
      color: colors[index],
    }));

  const seriesData = {
    apps: appsData.map(({ id, color }, index) => ({ x: index, y: series[id], color })),
    market_avg: appsData.map((_, index) => ({ x: index, y: series.market_avg })),
  };

  const metaSeriesData = {
    apps: {},
    market_avg: {
      type: 'spline',
      color: marketAvg.color,
      dashStyle: 'dash',
      lineWidth: 1,
    },
  };

  const chartConfig = {
    chart: {
      type: 'column',
      height: 162,
      backgroundColor: 'transparent',
      spacingBottom: 6,
      spacingLeft: 0,
    },
    title: {
      text: null,
    },
    tooltip: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    xAxis: {
      crosshair: false,
      labels: {
        enabled: false,
      },
      lineWidth: 0,
      tickLength: 0,
    },
    yAxis: {
      min: 0,
      gridLineWidth: 1,
      gridLineColor: '#EDF0F5',
      labels: {
        format: '{value}d',
        style: {
          color: '#848EA1',
          fontSize: '12px',
        },
      },
      maxPadding: 0.05,
      title: {
        text: null,
      },
    },
    plotOptions: {
      column: {
        groupPadding: 0.05,
      },
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 280,
          },
          chartOptions: {
            chart: {
              height: 200,
            },
          },
        },
      ],
    },
  };

  return (
    <Fragment>
      <SmartChart config={chartConfig} series={seriesData} metaSeriesData={metaSeriesData} />
      <ChartLegend selectedApps={appsData} hasAverage />
    </Fragment>
  );
};

ReleasesChart.propTypes = {
  series: T.object.isRequired,
  selectedApps: T.array.isRequired,
};

export default ReleasesChart;
